<template>
  <div class="sd-page">

    <!-- Hero -->
    <div class="sd-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-office-building-outline</v-icon>
        </v-avatar>
        <div>
          <div class="sd-hero__title">Sedes Registradas en el Sistema</div>
          <div class="sd-hero__sub">Gestión de sedes y sucursales</div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;" v-if="!$store.state.isonlyread && cid != 11 && cid != 12 && cid != 13">
        <router-link to="sedesadd" style="text-decoration:none;" v-if="$store.state.CARGO.id != 8 && $store.state.CARGO.id != 15 && $store.state.CARGO.id != 6">
          <v-btn small dark depressed color="rgba(255,255,255,0.18)">
            <v-icon left small>mdi-plus</v-icon> Nueva Sede
          </v-btn>
        </router-link>
        <router-link to="nits" style="text-decoration:none;">
          <v-btn small dark depressed color="rgba(255,255,255,0.18)">
            <v-icon left small>mdi-file-document-outline</v-icon> NITs
          </v-btn>
        </router-link>
      </div>
    </div>

    <div class="sd-body">

      <!-- Toolbar -->
      <v-card outlined class="sd-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex flex-wrap align-center" style="gap:10px;">
          <v-chip x-small :color="datos.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ datos.length }} sede{{ datos.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-switch
            v-model="contraercolumnas"
            label="Contraer columnas"
            dense hide-details inset
            class="mt-0"
          />
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="sd-table-card">
        <v-data-table
          :headers="computedHeaders"
          :items="tableItems"
          :items-per-page="25"
          :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
          dense
          class="sd-table"
          no-data-text="Sin sedes registradas."
        >
          <!-- Sede -->
          <template v-slot:[`item.nombre`]="{ item }">
            <span class="font-weight-medium" :title="'id: ' + item.id">{{ item.nombre }}</span>
          </template>

          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <div class="d-flex" style="gap:4px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="indigo darken-1" v-on="on" @click="selecionar(item.raw); dialogMapa = true">
                    <v-icon>mdi-map-marker-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver en mapa</span>
              </v-tooltip>

              <v-tooltip bottom v-if="cid == 1 || cid == -6">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="grey darken-1" v-on="on" @click="editarSede(item.raw)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar sede</span>
              </v-tooltip>

              <v-tooltip bottom v-if="cid == 1 || cid == 8">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="teal darken-1" v-on="on"
                    @click="$router.push('/sucursalesbysede?idsede=' + item.id)">
                    <v-icon>mdi-domain</v-icon>
                  </v-btn>
                </template>
                <span>Ver sucursales</span>
              </v-tooltip>
            </div>
          </template>

        </v-data-table>
      </v-card>

    </div>

    <!-- Dialog Mapa -->
    <v-dialog v-model="dialogMapa" max-width="600">
      <v-card>
        <v-card-title class="sd-dialog-title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-map-marker-outline</v-icon>
          Ubicación — {{ seleccionado.nombre }}
          <v-spacer />
          <v-btn icon small @click="dialogMapa = false"><v-icon small>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <div id="mapa" style="width:100%; height:400px;"></div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-4 py-2">
          <v-spacer />
          <v-btn small text @click="dialogMapa = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alertas ref="alertar" />
  </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue';
import { mapState } from 'vuex';

export default {
  components: { Alertas },
  data() {
    return {
      mapa: null,
      contraercolumnas: true,
      dialogMapa: false,
      seleccionado: { nombre: '' },
      negocio: process.env.VUE_APP_NAME,
      headersBase: [
        { text: 'Nro',        value: 'nro',           width: 60,  sortable: false },
        { text: 'Sede',       value: 'nombre' },
        { text: 'Ciudad',     value: 'ciudad' },
        { text: 'Dirección',  value: 'direccion' },
        { text: 'Teléfono 1', value: 'telefono1',     extended: true, width: 120 },
        { text: 'Teléfono 2', value: 'telefono2',     extended: true, width: 120 },
        { text: 'Fijo',       value: 'telefono_fijo', extended: true, width: 120 },
        { text: 'Aulas',      value: 'aulas',         extended: true, width: 80 },
        { text: 'Opciones',   value: 'opciones',      width: 130,  sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      datos: (state) => (state.UNIDAD_NEGOCIO_ID
        ? state.modsede.items.filter((item) => item.unidad_negocio == state.UNIDAD_NEGOCIO_ID)
        : []),
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
    cid() { return this.$store.state.CARGO.id; },
    computedHeaders() {
      return this.headersBase.filter(h => !h.extended || !this.contraercolumnas);
    },
    tableItems() {
      return this.datos.map((sede, i) => ({
        nro: i + 1,
        id: sede.id,
        nombre: sede.nombre,
        ciudad: this.parseCiudad(sede.ciudad),
        direccion: sede.direccion,
        telefono1: sede.telefono1,
        telefono2: sede.telefono2,
        telefono_fijo: sede.telefono_fijo,
        aulas: this.parseAulas(sede.aulas),
        raw: sede,
      }));
    },
  },
  watch: {
    UNIDAD_NEGOCIO_ID() {},
    seleccionado() {
      if (!this.mapa) return;
      if (this.seleccionado.latitud) {
        var thiz = this;
        this.mapa.setZoom(18);
        this.mapa.setCenter({ lat: this.seleccionado.latitud, lng: this.seleccionado.longitud });
        new window.google.maps.Marker({
          position: { lat: thiz.seleccionado.latitud, lng: thiz.seleccionado.longitud },
          map: thiz.mapa,
          title: 'Hello World!',
        });
      } else {
        this.mapa.setZoom(5);
        this.mapa.setCenter({ lat: -17.082262, lng: -63.576108 });
      }
    },
  },
  methods: {
    parseCiudad(c) {
      if (c == null) return '';
      var dep = c.departamento;
      if (dep) return c.nombre + ' (' + dep.nombre + ')';
      return c.nombre;
    },
    parseAulas(a) {
      if (a == null) return 0;
      return a.length;
    },
    selecionar(sel) {
      this.seleccionado = sel;
    },
    editarSede(sede) {
      window.sessionStorage.setItem('xsede', JSON.stringify(sede));
      this.$router.push({ name: 'sedesmod' });
    },
    iniciarMapa() {
      var mapita = document.getElementById('mapa');
      this.mapa = new window.google.maps.Map(mapita, {
        center: { lat: -17.082262, lng: -63.576108 },
        zoom: 5,
      });
    },
  },
  mounted() {
    this.iniciarMapa();
  },
};
</script>

<style scoped>
.sd-page { min-height: 100vh; background: #f5f7fa; }

.sd-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.sd-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.sd-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.sd-body { padding: 20px 24px; }

.sd-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.sd-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.sd-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.sd-table >>> tbody tr:hover { background: #f0f4ff !important; }
.sd-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}

.sd-dialog-title {
  font-size: 0.88rem !important;
  font-weight: 700 !important;
  color: #283593;
  border-bottom: 1px solid #e8edf7;
}
</style>
